console.log('LEANY variant media JS loaded');

(function () {
if (window.LeanyVariantMediaFixLoaded) return;
window.LeanyVariantMediaFixLoaded = true;

var productCache = {};

function cleanText(value) {
return String(value || '')
.replace(/\s+/g, ' ')
.trim();
}

function compareText(value) {
return cleanText(value).toLowerCase();
}

function getProductHandle() {
var parts = window.location.pathname.split('/');
var productIndex = parts.indexOf('products');

if (productIndex === -1) return '';
return parts[productIndex + 1] || '';

}

function getProductData(handle) {
if (!handle) return Promise.resolve(null);
if (productCache[handle]) return Promise.resolve(productCache[handle]);

return fetch('/products/' + handle + '.js')
  .then(function (response) {
    if (!response.ok) return null;
    return response.json();
  })
  .then(function (product) {
    productCache[handle] = product;
    return product;
  })
  .catch(function () {
    return null;
  });

}

function getVariantPicker(target) {
if (target && target.closest) {
var closestPicker = target.closest('variant-picker');
if (closestPicker) return closestPicker;
}

return document.querySelector('variant-picker');

}

function getLabelText(input) {
if (!input) return '';

var text = '';
var fieldset = input.closest('fieldset');

if (fieldset && input.id) {
  var labels = fieldset.querySelectorAll('label');

  Array.prototype.forEach.call(labels, function (label) {
    if (label.getAttribute('for') === input.id) {
      text =
        label.getAttribute('aria-label') ||
        label.getAttribute('title') ||
        label.getAttribute('data-option-value') ||
        label.getAttribute('data-value') ||
        label.textContent ||
        '';
    }
  });
}

if (!text) text = input.getAttribute('aria-label') || '';
if (!text) text = input.getAttribute('title') || '';
if (!text) text = input.getAttribute('data-option-value') || '';
if (!text) text = input.getAttribute('data-value') || '';
if (!text) text = input.value || '';

return cleanText(text);

}

function getSelectedOptions(picker) {
var options = [];

if (!picker) return options;

var fieldsets = picker.querySelectorAll('fieldset');

Array.prototype.forEach.call(fieldsets, function (fieldset) {
  var checked = fieldset.querySelector('input[type="radio"]:checked');

  if (checked) {
    options.push(getLabelText(checked));
  }
});

var selects = picker.querySelectorAll('select');

Array.prototype.forEach.call(selects, function (select) {
  if (select.value) {
    var selectedOption = select.options[select.selectedIndex];
    options.push(selectedOption ? cleanText(selectedOption.textContent) : cleanText(select.value));
  }
});

return options;

}

function findVariant(product, selectedOptions) {
if (!product || !product.variants || !selectedOptions.length) return null;

for (var i = 0; i < product.variants.length; i++) {
  var variant = product.variants[i];
  var variantOptions = variant.options || [];

  if (!variantOptions.length) {
    variantOptions = [variant.option1, variant.option2, variant.option3].filter(Boolean);
  }

  var matched = true;

  for (var j = 0; j < selectedOptions.length; j++) {
    if (compareText(variantOptions[j]) !== compareText(selectedOptions[j])) {
      matched = false;
      break;
    }
  }

  if (matched) return variant;
}

return null;

}

function getProductForm(picker) {
if (picker) {
var formId = picker.getAttribute('form-id');

  if (formId) {
    var formById = document.getElementById(formId);
    if (formById) return formById;
  }
}

return document.querySelector('form[action*="/cart/add"]');

}

function updateVariantId(form, variant) {
if (!form || !variant || !variant.id) return;

var input = form.querySelector('input[name="id"]');

if (!input) {
  input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'id';
  form.appendChild(input);
}

input.disabled = false;
input.value = variant.id;

console.log('LEANY selected variant ID:', variant.id);

}

function updateSelectedLabels(picker, selectedOptions) {
if (!picker || !selectedOptions.length) return;

var fieldsets = picker.querySelectorAll('fieldset');

Array.prototype.forEach.call(fieldsets, function (fieldset, index) {
  var legend = fieldset.querySelector('legend');

  if (!legend || !selectedOptions[index]) return;

  var currentText = legend.textContent || '';
  var baseText = currentText.split('：')[0].split(':')[0];

  legend.textContent = baseText + '：' + selectedOptions[index];
});

}

function getVariantMediaId(variant) {
if (!variant) return '';

if (variant.featured_media && variant.featured_media.id) {
  return String(variant.featured_media.id);
}

if (variant.featured_image && variant.featured_image.id) {
  return String(variant.featured_image.id);
}

return '';

}

function moveToElement(element) {
if (!element) return;

var elementId = element.getAttribute('id');

if (elementId) {
  var trigger =
    document.querySelector('[aria-controls="' + elementId + '"]') ||
    document.querySelector('a[href="#' + elementId + '"]');

  if (trigger) {
    trigger.click();
    return;
  }
}

element.scrollIntoView({
  behavior: 'smooth',
  block: 'nearest',
  inline: 'nearest'
});

}

function moveToMedia(mediaId) {
if (!mediaId) return;

var mediaElement =
  document.querySelector('[data-media-id="' + mediaId + '"]') ||
  document.querySelector('[data-media-id$="-' + mediaId + '"]') ||
  document.querySelector('[data-media-id*="' + mediaId + '"]');

if (mediaElement) {
  moveToElement(mediaElement);
}

}

function handleVariantChange(target) {
var picker = getVariantPicker(target);

if (!picker) {
  console.log('LEANY variant picker not found');
  return;
}

window.setTimeout(function () {
  var selectedOptions = getSelectedOptions(picker);
  var handle = getProductHandle();

  console.log('LEANY selected options:', selectedOptions);

  getProductData(handle).then(function (product) {
    if (!product) {
      console.log('LEANY product data not found');
      return;
    }

    var variant = findVariant(product, selectedOptions);

    if (!variant) {
      console.log('LEANY matching variant not found:', selectedOptions);
      return;
    }

    var form = getProductForm(picker);

    updateVariantId(form, variant);
    updateSelectedLabels(picker, selectedOptions);
    moveToMedia(getVariantMediaId(variant));
  });
}, 150);

}

document.addEventListener('change', function (event) {
var target = event.target;

if (!target || !target.matches) return;

if (
  target.matches('variant-picker input[type="radio"]') ||
  target.matches('variant-picker select')
) {
  handleVariantChange(target);
}

});

document.addEventListener('click', function (event) {
var target = event.target;

if (!target || !target.closest) return;

if (target.closest('variant-picker')) {
  window.setTimeout(function () {
    handleVariantChange(target);
  }, 200);
}

});

document.addEventListener('DOMContentLoaded', function () {
var picker = document.querySelector('variant-picker');

if (picker) {
  handleVariantChange(picker);
}

});
})();